<template>
    <div class="products-main">
      <app-header :cover="cover" :texts="texts" :hideScroll="true"></app-header>
        <div class="products-buttons-wrapper" v-if="!rolledSelected">
          <a v-scroll-reveal class="buttons-big" @click.prevent="rolledSelected = true">
            <img class="buttons-img" src="/static/img/products/rolled.png" alt="">
            <span>Rolled products</span>
          </a>
          <router-link v-scroll-reveal to="/products/extruded/profiles-for-building-and-architecture" class="buttons-big">
            <img class="buttons-img" src="/static/img/products/extruded.png" alt="">
            <span>Extruded products</span>
          </router-link>
        </div>
        <transition name="rolled">
          <div class="products-buttons-wrapper" v-if="rolledSelected">
            <router-link v-scroll-reveal to="/products/rolled-foils/household-foil" class="buttons-big buttons-small" @click.prevent="rolledSelected = true">
              <img class="buttons-img" src="/static/img/products/foils.png" alt="">
              <span>Foils</span>
            </router-link>
            <router-link v-scroll-reveal to="/products/rolled-sheets-and-strips/standard-sheets-and-strips" class="buttons-big buttons-small">
              <img class="buttons-img" src="/static/img/products/ss.png" alt="">
              <span>Sheets and Strips</span>
            </router-link>
          </div>
        </transition>
    </div>
</template>

<script>
import Header from "./shared/Header";
export default {
  components: {
    appHeader: Header
  },
  data() {
    return {
      cover: ["/static/img/products/header.jpg", "image"],
      texts: ["Alcomet products"],
      rolledSelected: false
    };
  }
};
</script>

<style>
.products-main {
  position: relative;
}
.products-buttons-wrapper {
  align-items: center;
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}
.buttons-big {
  align-items: center;
  flex-direction: column;
  display: flex;
  justify-content: flex-start;
  margin: 0 2%;
  width: 23%;
}
.buttons-img {
  border-radius: 50%;
  -webkit-box-shadow: 0px 0px 100px -10px rgba(0, 0, 0, 1);
  -moz-box-shadow: 0px 0px 100px -10px rgba(0, 0, 0, 1);
  box-shadow: 0px 0px 100px -10px rgba(0, 0, 0, 1);
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 100%;
  max-width: 100%;
  flex-shrink: 0;
}
.buttons-big > span {
  color: #fff;
  font-size: 24px;
  margin-top: 15px;
  position: relative;
  z-index: 1;
}
.buttons-small {
  width: 22%;
}
.buttons-big:hover .buttons-img {
  -webkit-box-shadow: 0 0 200px -10px #000;
  -moz-box-shadow: 0 0 200px -10px #000;
  box-shadow: 0 0 200px -10px #000;
  transform: scale(1.02);
}
/* ANIMATIONS */
.rolled-enter-active,
.rolled-leave-active {
  transition: all 0.4s ease;
}
.rolled-enter, .rolled-leave-to /* .fade-leave-active below version 2.1.8 */ {
  width: 23%;
  left: 30%;
}
@media screen and (max-width: 1440px) {
  .buttons-big {
    width: 17%;
  }
  .buttons-small {
    width: 16%;
  }
}
@media screen and (max-width: 1000px) {
  .products-buttons-wrapper {
    height: initial;
    overflow: initial;
    padding: 25px 0;
    position: static;
  }
  .buttons-big {
    margin: 15px;
    position: relative;
    width: 30%;
    z-index: 9;
  }
  .buttons-small {
    width: 25%;
  }
  .buttons-big > span {
    color: #004787;
    font-size: 18px;
    text-align: center;
    white-space: nowrap;
  }
}
@media screen and (max-width: 440px) {
  .products-buttons-wrapper {
    flex-direction: column;
  }
  .buttons-big {
    margin: 15px 0;
    position: relative;
    width: 50%;
    z-index: 9;
  }
  .buttons-small {
    width: 45%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProductsMain.vue